<span class="contact-type">
  {{ label$ | async }}
</span>
